module.exports = __webpack_public_path__ + "img/dingxiligong_login.206fcea5.jpg";